import { Flex, Paper, Text } from '@shared/components';

export default function ReportsPage() {
  return (
    <Flex sx={{ flexDirection: 'column', height: '100dvh' }}>
      <Text variant='h1' sx={(theme) => ({ p: theme.spacing(6, 8) })}>
        รายงาน
      </Text>
      <Flex sx={(theme) => ({ p: theme.spacing(6) })}>
        <Paper
          sx={(theme) => ({
            p: theme.spacing(6),
            width: '100%',
            gap: theme.spacing(6),
            display: 'flex',
            flexDirection: 'column',
          })}
        ></Paper>
      </Flex>
    </Flex>
  );
}
